<template>
  <div>
    <section class="banner-bottom py-5">
      <div class="container py-md-3">
        <h4 class="text-center" data-aos="zoom-in">
          Ils nous ont fait confiance
        </h4>
        <ul class="list-unstyled pt-5 partners-icon text-center">
          <li data-aos="fade-up" title="Pero Groupe Sarl">
            <i>
              <img style="height: 55px" src="images/pero-groupe.png" alt="" />
            </i>
          </li>
          <li data-aos="fade-up" style="background-color: #7E7E7E;" title="Jscom Bénin">
            <i>
              <img style="height: 55px" src="images/jscom.png" alt="" />
            </i>
          </li>
          <li data-aos="fade-up" title="Fédération Adventiste au Bénin">
            <i>
              <img style="height: 55px" src="images/fab.jpg" alt="" />
            </i>
          </li>
          <li data-aos="fade-up" title="Cronos Technology Center">
            <i>
              <img style="height: 55px" src="images/ctc.png" alt="" />
            </i>
          </li>
          <li data-aos="fade-up" title="Bénin Building Services">
            <i>
              <img style="height: 55px" src="images/bbs.png" alt="" />
            </i>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Banner-Item",
};
</script>

<style scoped>
</style>